import { artBoardActions } from '@store/reducers/artboard'
import cs from 'classnames'
import type React from 'react'
import { useState } from 'react'
import { useDispatch } from 'react-redux'

import type { AttachmentItem } from '@/types'
import { AttachedFileWrapper } from '../AttachedFileWrapper'
import css from './ImageThumbnail.module.scss'

interface Props {
  file: AttachmentItem
  selected: boolean
}

export const ImageThumbnail: React.FC<Props> = ({ file, selected }) => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)
  const onDoubleClick = () => {
    dispatch(artBoardActions.setPreview(file.downloadUrl))
  }

  return (
    <AttachedFileWrapper selected={selected}>
      <img
        onLoad={() => setLoading(false)}
        onDoubleClick={onDoubleClick}
        className={cs(css.thumbnail, { [css.loading]: loading })}
        draggable={false}
        src={file.downloadUrl}
        alt={file.filename}
      />
    </AttachedFileWrapper>
  )
}
